
import { useNavigate } from "react-router-dom";
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useReporteStockStore } from "../../../stores";
import { LayoutTabla } from "../../layouts";
import { MensajeAlertaDanger } from "../../components";
import { separadorMillares } from "../../../hooks";
import { fechaConHora } from "../../../helpers/prepararFecha";



const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaReporteInventario = ({ data, chagePage, page, view=false }) => {


    const navigate = useNavigate();
    const { totalReproteStock } = useReporteStockStore();


    const handleIrAOp = (id) => {
        navigate(`/super/detalles-op/${id}`)
    }


    return (
        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalReproteStock / +paginado)} disabled={Math.ceil(totalReproteStock / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'15%'}}>Fecha</TableCell>
                        {(view) && <TableCell sx={{width:'20%'}}>Producto</TableCell>}
                        {(!view) && <TableCell sx={{width:'10%'}}>Inicial</TableCell>}
                        <TableCell sx={{width:'10%'}}>Cantidad</TableCell>
                        {(!view) && <TableCell sx={{width:'10%'}}>Final</TableCell>}
                        <TableCell sx={{width:'15%'}}>Valor</TableCell>
                        {(view) 
                        ?   <TableCell sx={{width:'15%'}}>Total</TableCell>
                        :   <TableCell sx={{width:'20%'}}>Ajuste</TableCell>
                        }
                        <TableCell sx={{width:'20%'}}>User</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                {data.map((a) => (
                    <TableRow key={a._id}>
                        <TableCell>{ fechaConHora(a?.createdAt) }</TableCell>
                        {(view) && <TableCell sx={{width:'15%'}}>{a.stock.nombre}</TableCell>}
                        {(!view) && <TableCell>{ a.inicial }</TableCell>}
                        <TableCell sx={{ color: a.cantidad < 1 ? 'error.main' : 'success.main' }}>
                            <Typography variant="body2" sx={{ fontWeight:900 }}>{ a.cantidad }</Typography>
                        </TableCell>
                        {(!view) && <TableCell>{ a.final }</TableCell>}
                        <TableCell>{ `$${separadorMillares(a.precio)}` }</TableCell>
                        {(view) 
                        ?   <TableCell>{`$${separadorMillares(a.precio * Math.abs(a.cantidad))}`}</TableCell>
                        :   <TableCell sx={{cursor:'pointer'}} onClick={a.op ? () => handleIrAOp(a.op.id) : undefined}>
                                {(a.op) ? `OP-${a.op.op}` : a.motivoAjuste }
                            </TableCell>
                        }
                        
                        <TableCell>{ a.admin.nombre }</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>
        :   <MensajeAlertaDanger titulo='No hay movimientos de este producto...' />
        }
        </>
    )
}